import { getHoverColor } from "@/utils/colorUtils"
import { $color } from "@/utils/cssVarUtils"
import { listAnatomy as parts } from "@chakra-ui/anatomy"
import type {
  PartsStyleFunction,
  SystemStyleFunction,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"


const baseStyleContainer: SystemStyleObject = {
  '> li:not(style)~*:not(style)': {
    mt: 0,
  }
}

const baseStyleIcon: SystemStyleObject = {
  marginEnd: "0.5rem",
  display: "inline",
  verticalAlign: "text-bottom",
}

const baseStyleItem: SystemStyleFunction = (props) => {
  const hoverColor = getHoverColor(props)

  return {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid',
    borderColor: $color('scene-border'),
    px: 'md',
    py: 0,
    height: '7xl',
    _focus: {
      boxShadow: "none",
    },
    _hover: {
      bg: hoverColor,
    },
    _last: {
      borderBottom: 'none',
    }
  }
}

const baseStyle: PartsStyleFunction<typeof parts> = (props) => {
  return {
    container: baseStyleContainer,
    item: baseStyleItem(props),
    icon: baseStyleIcon,
  }
}

export const List = {
  parts: parts.keys,
  baseStyle,
}